import { ResizeControlProps } from "../../types";

const Resize = ({
  isShow,
  isAddedImage,
  resizeIsOpenSelect,
  resizeSetOpenSelect,
  resizeFormat,
  inputWidth,
  inputHeight,
  canvasWidth,
  canvasHeight,
  inputWidthValue,
  inputHeightValue,
  warningWidth,
  warningHeight,
  imageHeight,
  imageWidth,
  warningText,
  resizeIsSaveProportion,
  resizeInputChangeHandler,
  resizeClickOptionHandler,
  resizeSetSaveProportions,
  setWarningWidth
}: ResizeControlProps): JSX.Element => {

  if(!isShow) return <></>;

  return (
    <form className="service__control-form form">
      <div className="form__group">
        {getDimensionProp(warningText, warningWidth, resizeInputChangeHandler, inputWidth, canvasWidth, isAddedImage, 'width', resizeIsSaveProportion, imageWidth, imageHeight, canvasWidth,
  canvasHeight, setWarningWidth)}

        <button style={{ fontSize: 0 }} type="button" disabled={!isAddedImage} onClick={() => { resizeSetSaveProportions(resizeIsSaveProportion) }}>
          lock <i className={resizeIsSaveProportion ? "icon__lock" : "icon__un-lock"}/>
        </button>
        {getDimensionProp(warningText, warningHeight, resizeInputChangeHandler, inputHeight, canvasHeight, isAddedImage, 'height', resizeIsSaveProportion, imageWidth, imageHeight, canvasWidth,
  canvasHeight, setWarningWidth)}
      </div>

      <div className="form__group form__group_lite">
        <label>
          <span>Save as</span>
          <div className="select-list">
            <div
              style={{ opacity: isAddedImage ? "1" : "0.5" }}
              className={"arrow " + (resizeIsOpenSelect ? "arrow_active" : "")}
            ></div>
            <input
              type="text"
              value={(resizeFormat + '').split("/").pop().toUpperCase()}
              readOnly
              className={"select " + (resizeIsOpenSelect ? "select_active" : "")}
              onClick={() => resizeSetOpenSelect(!resizeIsOpenSelect)}
              disabled={!isAddedImage}
            />
            <div
              className="options"
              style={{ display: resizeIsOpenSelect ? "flex" : "none" }}
            >
              {getOptionItems([{format: 'JPEG', type: 'image/jpeg'}, {format: 'PNG', type: 'image/png'}], resizeClickOptionHandler, resizeIsOpenSelect, resizeSetOpenSelect)}
            </div>
          </div>
        </label>
      </div>
    </form>
  );
};

const getOptionItems = (items, clickOptionHandler, resizeIsOpenSelect, resizeSetOpenSelect) => {
  return items.map((item, index) => {
    return (
      <button className="option" key={index} type="button" onClick={() => { clickOptionHandler(item.type, resizeIsOpenSelect, resizeSetOpenSelect) }}>
        {item.format}
      </button>
    );
  });
};

const getDimensionProp = (warningText, warningProp, changeHandler, inputRef, value, isImageAdded, changeProps, resizeIsSaveProportion, imageWidth, imageHeight, canvasWidth,
  canvasHeight, setWarningWidth) => {

  return (
    <label>
      <span>{changeProps.charAt(0).toUpperCase() + changeProps.slice(1)}, px</span>
      <input 
        type="text" 
        className={warningProp ? "warning-style" : ""} 
        onChange={(e) => changeHandler(e, changeProps, resizeIsSaveProportion, imageWidth, imageHeight, canvasWidth, canvasHeight, setWarningWidth)} 
        ref={inputRef} 
        value={value ? value : 0} 
        disabled={!isImageAdded}
      />
      <span className="warning-text" style={{ visibility: warningProp ? "visible" : "hidden"}}>
        {warningText[warningProp]}
      </span>
    </label>
  );
}

export default Resize;
